<template>
    <el-form :model="merchantBizRel" :rules="merchantBizRelRules" :label-position="'left'" ref="merchantBizRelInfo">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">商户名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="peerMerchantName">
                        <el-input class="width-2x bottom-line" :disabled="true" v-model="merchantBizRel.peerMerchantName"></el-input>
                        <i v-if="merchantBizRel.id == null" class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" @click="vendorSelect"></i>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>商户编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="peerMerchantNo">
                        <el-input class="width-2x bottom-line" :disabled="true" v-model="merchantBizRel.peerMerchantNo"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>统一社会信用代码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="peerSocialCreditCode">
                        <el-input class="width-2x bottom-line" :disabled="true" v-model="merchantBizRel.peerSocialCreditCode"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>组织机构代码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="peerOrgCode">
                        <el-input class="width-2x bottom-line" :disabled="true" v-model="merchantBizRel.peerOrgCode"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>业务联系人</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerContactName">
                        <el-input v-model="merchantBizRel.peerContactName" placeholder="请输入业务联系人"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>业务联系方式</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerContactTel">
                        <el-input v-model="merchantBizRel.peerContactTel" placeholder="请输入业务联系方式"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="merchantType != venderType">
                <div class="form-label">
                    <label class="required">{{merchantType == venderType ? '供应商' : '服务商'}}标识</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerInnerCode">
                        <el-input v-model="merchantBizRel.peerInnerCode" :placeholder="placeholderTitle"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行行号</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerBankCode">
                        <el-input v-model="merchantBizRel.peerBankCode" placeholder="请输入银行行号"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行名称</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerBankName">
                        <el-input v-model="merchantBizRel.peerBankName" placeholder="请输入银行名称"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行账号</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerCardNo">
                        <el-input v-model="merchantBizRel.peerCardNo" placeholder="请输入银行账号"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行卡号</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerAcctNo">
                        <el-input v-model="merchantBizRel.peerAcctNo" placeholder="请输入银行卡号"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>银行卡开户名</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="peerAcctName">
                        <el-input v-model="merchantBizRel.peerAcctName" placeholder="请输入银行开户名"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">关系开始日期</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="dateStart">
                        <el-date-picker v-model="merchantBizRel.dateStart" type="date" value-format="yyyy-MM-dd" placeholder="关系开始日期"></el-date-picker>
                    </el-form-item>
                </div>

            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">关系截止日期</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="dateEnd">
                        <el-date-picker v-model="merchantBizRel.dateEnd" type="date" value-format="yyyy-MM-dd" placeholder="关系截止日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">评级</label>
                </div>
                <div class="form-value width-2x" prop="starLevel">
                    <el-rate v-model="merchantBizRel.starLevel"></el-rate>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">业务描述</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="bizDesc">
                        <textarea v-model="merchantBizRel.bizDesc"></textarea>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<!--商户业务关系编辑-->
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import { openServicerSelectComnDlg } from '../servicer/selectDlg'

    import merchtFinacApi from '../../api/merchtFinac'
    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-modify-merchant-biz-rel',
        desc: '商户业务关系-编辑',
        props: ['id', 'merchantType'],
        data: function () {
            let self = this;
            let checkStarLevel = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('星级标记不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateStart = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('关系开始日期不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateEnd = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    return callback(new Error('关系截止日期不能为空!'));
                } else if(value.format("yyyy-MM-dd") < self.merchantBizRel.dateStart.format("yyyy-MM-dd")) {
                    callback(new Error('关系截止日期不能比关系开始日期小！'));
                } else {
                    callback();
                }
            };
            let checkBizDesc = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('业务描述不能为空!'));
                } else {
                    callback();
                }
            };
            let checkPeerContactTel = function (rule, value, callback) {
                if(!Utils.isNoB(value)) {
                    if(!Utils.isPhoneNo(value)) {
                        callback(new Error('业务联系方式错误!'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let checkIsNull = function (rule, value, callback) {
                if(!Utils.isNoB(value)) {
                    if(value.length > 30) {
                        callback(new Error('不可大于30!'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            let checkPeerInnerCode = function (rule, value, callback) {
                let title = self.merchantType == self.venderType ? '供应商' : '服务商';
                if(!Utils.isNoB(value)) {
                    if(value.length > 15) {
                        callback(new Error(title + '标识不可大于15!'));
                    } else {
                        callback();
                    }
                } else {
                    callback(new Error(title + '标识不可为空!'));
                }
            };
            let checkBankCode = function (rule, value, callback) {
                if(!Utils.isNoB(value)) {
                    if(value.length > 15) {
                        callback(new Error('不可大于15!'));
                    } else {
                        if(value.search((/^[A-Za-z0-9]+$/)) != -1) {
                            callback();
                        } else {
                            callback(new Error('不可包含汉字或特殊字符!'));
                        }
                    }
                } else {
                    callback();
                }
            };
            let checkNo = function (rule, value, callback) {
                if(!Utils.isNoB(value)) {
                    if(value.length > 30) {
                        callback(new Error('不可大于30!'));
                    } else {
                        if(value.search((/^[A-Za-z0-9]+$/)) != -1) {
                            callback();
                        } else {
                            callback(new Error('不可包含汉字或特殊字符!'));
                        }
                    }
                } else {
                    callback();
                }
            };
            return {
                merchantBizRel: {
                    peerMerchantName: null,
                    dateStart: null,
                    dateEnd: null,
                    starLevel: null,
                    type: null
                },
                servicerType: null,
                venderType: null,
                merchantBizRelRules: {
                    starLevel: [{validator: checkStarLevel, trigger: 'blur'}],
                    dateStart: [{validator: checkDateStart, trigger: 'blur'}],
                    dateEnd: [{validator: checkDateEnd, trigger: 'blur'}],
                    bizDesc: [{validator: checkBizDesc, trigger: 'blur'}],
                    peerContactTel: [{validator: checkPeerContactTel, trigger: 'blur'}],
                    peerBankCode: [{validator: checkBankCode, trigger: 'blur'}],
                    peerBankName: [{validator: checkIsNull, trigger: 'blur'}],
                    peerCardNo: [{validator: checkNo, trigger: 'blur'}],
                    peerAcctNo: [{validator: checkNo, trigger: 'blur'}],
                    peerAcctName: [{validator: checkIsNull, trigger: 'blur'}],
                    peerInnerCode: [{validator: checkPeerInnerCode, trigger: 'blur'}]
                },
                placeholderTitle: null,
            }
        },
        created: function () {
            this.venderType = getEnumInfoWith('merchantType', 'name', 'Vendor').value;
            this.servicerType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
            if(!Utils.isNoB(this.id)) {
                let self = this;
                merchtComnApi.getMerchantBizRel(self.id, function (result) {
                    if(result.type == 'info') {
                        self.merchantBizRel = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
            let title = this.merchantType == this.venderType ? '供应商' : '服务商';
            this.placeholderTitle = '请输入' + title + '标识';
        },
        methods: {
            vendorSelect: function () {
                let self = this;
                let merchantBizRel = self.merchantBizRel;
                let params = {
                    showContract: true,
                    showOrder: true,
                    showAdverseBizRel: true, // 卖方关联，备选其他
                    showAll: true,
                    multiSelect: false,
                    multiSelectDisabled: true
                };
                if(self.merchantType == self.venderType) {
                    openVendorSelectComnDlg(self, params, function (result) {
                        let selectMercht = result.checkedList || [];
                        merchantBizRel.peerMerchantName = selectMercht.name;
                        merchantBizRel.peerMerchantNo = selectMercht.no;
                        merchantBizRel.peerSocialCreditCode = selectMercht.socialCreditCode;
                        merchantBizRel.peerOrgCode = selectMercht.orgCode;
                        merchantBizRel.peerContactName = selectMercht.contactName;
                        merchantBizRel.peerContactTel = selectMercht.contactTel;
                        merchantBizRel.peerMerchantType = self.merchantType;
                        merchantBizRel.peerMerchantId = selectMercht.id;
                        self.merchantBizRel = Utils.merge({}, merchantBizRel);
                        self.getMerchantBankAcct(selectMercht.id, self.merchantType);
                    });
                } else {
                    openServicerSelectComnDlg(self, params, function (result) {
                        let selectMercht = result.checkedList || [];
                        merchantBizRel.peerMerchantName = selectMercht.name;
                        merchantBizRel.peerMerchantNo = selectMercht.no;
                        merchantBizRel.peerSocialCreditCode = selectMercht.socialCreditCode;
                        merchantBizRel.peerOrgCode = selectMercht.orgCode;
                        merchantBizRel.peerContactName = selectMercht.contactName;
                        merchantBizRel.peerContactTel = selectMercht.contactTel;
                        merchantBizRel.peerMerchantType = self.merchantType;
                        merchantBizRel.peerMerchantId = selectMercht.id;
                        self.merchantBizRel = Utils.merge({}, merchantBizRel);
                        self.getMerchantBankAcct(selectMercht.id, self.merchantType);
                    })
                }
            },
            getMerchantBankAcct: function (merchantId, merchantType) {
                let self = this;
                let postData = {
                    merchantId: merchantId,
                    merchantType: merchantType
                };
                merchtComnApi.getRealComBankAcctDefaulted(postData, function (result) {
                    if(result.type == "info") {
                        let merchantBankAcct = result.data || null;
                        if(!Utils.isNoB(merchantBankAcct)) {
                            let merchantBizRel = self.merchantBizRel || {};
                            merchantBizRel.peerBankCode = merchantBankAcct.bankCode;
                            merchantBizRel.peerBankName = merchantBankAcct.bankName;
                            merchantBizRel.peerCardNo = merchantBankAcct.cardNo;
                            merchantBizRel.peerAcctNo = merchantBankAcct.acctNo;
                            merchantBizRel.peerAcctName = merchantBankAcct.acctName;
                            self.merchantBizRel = Utils.merge({}, merchantBizRel);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['merchantBizRelInfo'].validate(function (valid) {
                    if(valid) {
                        let merchantBizRel = Utils.merge({}, self.merchantBizRel);
                        if(Utils.isNoB(merchantBizRel.peerMerchantId)) {
                            let title = self.merchantType == self.venderType ? '供应商' : '服务商';
                            result.type = "warn";
                            result.message = title + "不能为空";
                            return result;
                        } else {
                            if(Utils.isNoB(self.merchantBizRel.starLevel) || self.merchantBizRel.starLevel <= 0) {
                                result.type = "warn";
                                result.message = "星级标记不能为空";
                            } else {
                                result.type = "info";
                                result.data = merchantBizRel;
                            }
                        }
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
        },
    }
</script>





// WEBPACK FOOTER //
// src/compo/merchant/ModifyMerchantBizRel.vue